<template>
    <div v-if="!hideAndroidAppBannerCookie && isVisible" class="appBanner" :style="`bottom: ${bottomPosition}px;`">
        <button class="appBanner__close" @click="close">✕</button>
        <div class="appBanner__icon">
            <img width="25" height="25" :alt="$t('mobileApp.android.alt')" src="/nuxt-assets/icons/pilulka.svg" loading="lazy" />
        </div>
        <div class="appBanner__text">
            <strong class="appBanner__text__title">{{ $t('mobileApp.banner.title') }}</strong>
            <span class="appBanner__text__info">{{ $t('mobileApp.banner.text') }}</span>
        </div>
        <a :href="mobileAppLink" class="appBanner__button btn btn-primary">
            {{ $t('mobileApp.banner.open') }}
        </a>
    </div>
</template>

<script lang="ts" setup>
const hideAndroidAppBannerCookie = useCookie<boolean>('hideAndroidAppBanner', {
    maxAge: 60 * 60 * 24, // 1 day
    secure: true,
})

const close = () => {
    hideAndroidAppBannerCookie.value = true
}

const bottomPosition = computed(() => {
    const route = useRoute()

    // @ts-ignore
    const componentName: string = route.matched[0]?.props.default.componentName

    if (['catalog.product'].includes(componentName)) {
        return 154
    }

    if (['cart.cart'].includes(componentName)) {
        return 168
    }

    if (['cart.step_2', 'cart.step_3'].includes(componentName)) {
        return 95
    }

    return 74
})

const mobileAppLink = ref(useMobileAppLink())

const isVisible = ref(true)
const device = useDevice()
onMounted(() => {
    isVisible.value = !device.isIos || !device.isSafari
    mobileAppLink.value = useMobileAppLink()
})
</script>

<style lang="scss" scoped>
.appBanner {
    display: flex;
    background-color: #fff4f2;
    padding: 7px 8px;
    align-content: center;

    position: fixed;
    left: 10px;
    right: 10px;
    border: 1px solid pink;
    border-radius: 13px;
    align-items: center;
    z-index: 98;
}

.appBanner__close {
    padding-left: 0;
}

.appBanner__icon {
    background-color: #fff;
    box-shadow: 0 0 19px -8px rgba(0, 0, 0, 0.33);
    width: 39px;
    height: 39px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    margin-right: 8px;
}

.appBanner__text {
    flex: 1;
    display: flex;
    justify-content: center;
    flex-direction: column;
}

.appBanner__text__title {
    display: block;
    font-size: 12px;
    line-height: 14px;
}

.appBanner__text__info {
    display: block;
    font-size: 11px;
    line-height: 12px;
}

.appBanner__button {
    font-size: 13px;
    line-height: 13px;
    padding: 0 13px;
    text-transform: uppercase;
    height: 29px;
    align-items: center;
    display: flex;
}
</style>
